import { createApp } from "vue";
import App from "./app.vue";
import i18n from "./i18n";
import Toast, { PluginOptions, POSITION } from "vue-toastification";
import "./styles/index.scss";
import { initParallax } from "./parallax";
import { unregisterServiceWorkers } from "./unregister-service-workers";

const app = createApp(App);

app.config.compilerOptions.delimiters = ["${", "}"];

app.use(i18n);

const routerPromises: Promise<void>[] = [];

if (document.querySelector('[is="vue:grocery-container"]')) {
  routerPromises.push(
    import("./features/grocery/router").then(({ groceryRouter }) => {
      app.use(groceryRouter);
    }),
  );
}

if (document.querySelector('[is="vue:reservation-container"]')) {
  routerPromises.push(
    import("./features/reservation/router").then(({ reservationRouter }) => {
      app.use(reservationRouter);
    }),
  );
}

const toastOptions: PluginOptions = {
  maxToasts: 5,
  timeout: 5000,
  position: POSITION.BOTTOM_RIGHT,
};
app.use(Toast, toastOptions);

Promise.all(routerPromises).then(() => {
  app.mount("#root");
});

if (document.querySelector("[data-embla-carousel]")) {
  import(
    /* webpackChunkName: "organizations" */ "./features/organizations/embla-carousel"
  ).then(({ initEmblaCarousels }) => {
    initEmblaCarousels();
  });
}

if (window.isHomePage) {
  initParallax();
}

// Poland launch contest landing page — temporary, remove with the landing page.
if (document.documentElement.classList.contains("lp")) {
  import("./features/landing/scroll-theme").then(({ initScrollTheme }) => {
    initScrollTheme();
  });
  import("./features/landing/reels").then(({ initReels }) => {
    initReels();
  });
}

unregisterServiceWorkers();

export default app;
